<!-- 
  产品详情页 - 保质期
    id: 详情产品id
  emit:暂无
 -->
 <template>
  <div class="guarantee-tab">
     <h1 v-if="specArray.length>1" class="theme"><i></i><span>产品规格</span></h1>
     <ul v-if="specArray.length>1" class="productCon listCPGG">
        <li v-for="(spec,index) in specArray" 
         :class="{active:index === tabNum}"
         @click="tabLi(spec.id,index)">
          {{spec.specification}}
        </li>
     </ul>
     <h1 class="theme"><i></i><span>保质期信息</span></h1>
     <div class="overdue" v-if="overTotal > 0">
      <span>已过期数量：{{overTotal}}</span>
     </div>
     <el-table
        border
        :data="tableData"
        style="width: 95%">
        <el-table-column
          label="仓库名称"
          width="180">
          <template slot-scope="scope">
            {{scope.row.warehouseName}}
          </template>
        </el-table-column>
        <el-table-column
          label="保质状况"
          width="150">
          <template slot-scope="scope">
            <span :style="scope.row.leftTime < 0 ? 'color:#FC484F' :'color:#000' ">
            {{getOver(scope.row.leftTime)}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="批次号"
          >
          <template slot-scope="scope">
            {{scope.row.batch}}
          </template>
        </el-table-column>
        <el-table-column
          label="数量"
          width="100">
          <template slot-scope="scope">
            {{scope.row.num}}
          </template>
        </el-table-column>
        <el-table-column
          label="生产日期"
          width="150">
          <template slot-scope="scope">
            {{scope.row.produceDate}}
          </template>
        </el-table-column>
        <el-table-column
          label="保质期（天）"
          width="150">
          <template slot-scope="scope">
            {{scope.row.guaranteePeriod}}
          </template>
        </el-table-column>
    </el-table>
  </div>
</template>
<script>
import * as api from 'src/api'
export default {
  created () {
    this.getTabCon()
  },
  props: {
    id: {
      type: Number
    }
  },
  data () {
    return {
      specArray: [], // 规格数组
      tabNum: 0, // 多规格当前选中索引
      tableData: [], // 表格数据数组
      overTotal: 0 // 过期总数
    }
  },
  methods: {
    // 获取接口
    getTabCon () {
      let url = `/productApi/getChildProductList.html`
      let params = {
        productId: this.id
      }
      api.post(url, params, (data) => {
        this.specArray = data.childProductList // 规格数组
        if (data.childProductList.length === 1 || data.childProductList[0]) {
          let id = data.childProductList[0].id
          this.getTableList(id)
        }
      })
    },

    // 多规格点击tab
    tabLi (id, index) {
      this.tabNum = index
      this.getTableList(id)
    },

    // 请求表格数据
    getTableList (id) {
      this.overTotal = 0 // 清除已过期数量
      let url = `/productStock/getGuaranteeInfo.html`
      let params = {
        productId: id
      }
      api.post(url, params, (data) => {
        this.tableData = data.resultArray
        // 计算过期数量
        this.tableData.map((item) => {
          if (item.leftTime < 0) {
            // this.overTotal += item.num
            this.overTotal = utils.plus(this.overTotal, item.num)
          }
        })
      })
    },

    // 过期状态
    getOver (time) {
      if (time < 0) {
        return '已过期'
      } else {
        return '剩余' + time + '天'
      }
    }

  }
}
</script>
<style lang="less">
  .guarantee-tab{
    .el-table{margin: 15px auto;}
  }
</style>
<style lang="less" scoped>
  .guarantee-tab{
    padding:0 15px;
    .theme{background:#F1F6FE;line-height: 30px;font-size:13px;}
    .theme i{display:inline-block;width:8px;height:8px;background:#FF943E;margin:0 10px;}
    .productCon{
      margin:15px 0 0;
      margin-left: 28px;
      display: flex;
      flex-wrap: wrap;
      &.listCPGG li{padding:10px 10px;border:1px solid #ccc;cursor: pointer;
        margin-right:15px;border-radius: 2px;margin-bottom: 10px;}
      &.listCPGG li.active{border:1px solid #FF943E;background:#FF943E;color:#fff;}
    }
    .overdue{
      margin-top: 15px;margin-left: 28px;color:#FC484F
    }
  }
</style>


// WEBPACK FOOTER //
// guarantee-tab.vue?4242dc70